import { useState, useEffect } from 'react'

export function useCountUp(
  end: number,
  duration: number = 2000,
  start: boolean = false,
) {
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!start) return
    let startTime: number | null = null
    let animationFrame: number

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp
      const progress = timestamp - startTime
      const percentage = Math.min(progress / duration, 1)
      const easeOut = percentage === 1 ? 1 : 1 - Math.pow(2, -10 * percentage)
      setCount(Math.floor(end * easeOut))
      if (progress < duration) {
        animationFrame = requestAnimationFrame(animate)
      } else {
        setCount(end)
      }
    }

    animationFrame = requestAnimationFrame(animate)
    return () => cancelAnimationFrame(animationFrame)
  }, [end, duration, start])

  return count
}
